import { LOS_DATA_TEST_ID } from '@e2e/constants/exam-management/los-page';
import { FormTextarea } from '@shared/components';
import type { KeyboardEvent } from 'react';
import { useFormContext } from 'react-hook-form';

interface LOSInputProps {
  name: string;
  label: string;
  helperText?: string;
  preventNewLine?: boolean;
}

export default function LOSInput(props: Readonly<LOSInputProps>) {
  const { name, label, helperText, preventNewLine: shouldPreventNewLine = false } = props;

  const { setValue } = useFormContext<{ los: string }>();

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    const isEnterKey = event.key === 'Enter';
    const isShiftEnter = isEnterKey && event.shiftKey;

    if (shouldPreventNewLine && (isEnterKey || isShiftEnter)) {
      event.preventDefault();
    }
  };

  const handleChange = (input: string) => {
    if (shouldPreventNewLine) {
      const inputWithoutNewLine = input.replace(/\s+/g, ' ');
      setValue('los', inputWithoutNewLine);
    }
  };

  return (
    <FormTextarea
      onKeyDown={handleKeyDown}
      data-testid={LOS_DATA_TEST_ID.LOS_NAME_INPUT}
      name={name}
      label={label}
      placeholder='กรุณากรอกหรือวางวัตถุประสงค์การเรียนรู้'
      helperText={helperText}
      required
      onChange={(event) => {
        handleChange(event.target.value);
      }}
    />
  );
}
